import { render, staticRenderFns } from "./AppEditDesign.vue?vue&type=template&id=2287c984&scoped=true"
import script from "./AppEditDesign.vue?vue&type=script&lang=js"
export * from "./AppEditDesign.vue?vue&type=script&lang=js"
import style0 from "./AppEditDesign.vue?vue&type=style&index=0&id=2287c984&prod&scoped=true&lang=css"
import style1 from "./AppEditDesign.vue?vue&type=style&index=1&id=2287c984&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2287c984",
  null
  
)

export default component.exports